module.exports = __webpack_public_path__ + "img/logo-h5.bda46503.png";